module.exports = __webpack_public_path__ + "img/illustrator-drawing-dark.1cba6ad1.svg";